import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "row c-media-from-computer" }
const _hoisted_2 = { class: "p15" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row txt-center" }
const _hoisted_5 = { class: "row txt-center" }
const _hoisted_6 = {
  for: "uploadMedia",
  class: "txt-detail"
}
const _hoisted_7 = ["multiple"]
const _hoisted_8 = {
  key: 0,
  class: "row mt15"
}
const _hoisted_9 = {
  class: "mv12",
  style: {"border":"1px solid var(--gray-dark)","border-radius":"var(--radius)","padding":"15px"}
}
const _hoisted_10 = { class: "row mt8" }
const _hoisted_11 = { class: "row mb18" }
const _hoisted_12 = { class: "go-right" }
const _hoisted_13 = { class: "font13 mr6" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = ["value", "checked"]
const _hoisted_17 = {
  class: "box-item-media",
  style: {"left":"45px"}
}
const _hoisted_18 = { class: "row image-thumbnail-desc" }
const _hoisted_19 = { class: "mv6 thumbnail-image-name" }
const _hoisted_20 = { class: "box-progress-bar" }
const _hoisted_21 = {
  key: 1,
  style: {width: '0%'},
  class: "progress-bar"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "btn-upload-right txt-right p15 pt0" }
const _hoisted_26 = {
  key: 0,
  class: "btn btn-danger btn-disabled btn-sm ml6"
}
const _hoisted_27 = {
  key: 1,
  class: "btn btn-danger btn-disabled btn-sm ml6"
}
const _hoisted_28 = { class: "mt15" }
const _hoisted_29 = {
  class: "row mv12",
  style: {"border":"1px solid var(--gray-dark)","border-radius":"var(--radius)","padding":"15px"}
}
const _hoisted_30 = { style: {"top":"-11px"} }
const _hoisted_31 = {
  class: "row",
  style: {"width":"100%"}
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = ["value"]
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  class: "box-item-media",
  style: {"left":"45px"}
}
const _hoisted_36 = {
  class: "row image-thumbnail-desc",
  style: {"width":"100%"}
}
const _hoisted_37 = { class: "mv6 mt15 thumbnail-image-name" }
const _hoisted_38 = {
  key: 0,
  class: "row mt15"
}

export function render(_ctx, _cache) {
  const _component_c_img = _resolveComponent("c-img")
  const _component_c_empty = _resolveComponent("c-empty")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onDragover: _cache[1] || (_cache[1] = (...args) => (_ctx.dragover && _ctx.dragover(...args))),
        onDragleave: _cache[2] || (_cache[2] = (...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
        onDrop: _cache[3] || (_cache[3] = (...args) => (_ctx.drop && _ctx.drop(...args))),
        class: "drop-media-controller"
      }, [
        _createElementVNode("img", {
          src: require('@/assets/icons/upload.png'),
          class: "w62"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t("componentDragAndDropFile")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t("componentUploadFromComputer")) + " ", 1),
          _createElementVNode("label", _hoisted_6, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t("componentHere")), 1)
          ]),
          _createElementVNode("input", {
            onChange: _cache[0] || (_cache[0] = (...args) => (_ctx.onChange && _ctx.onChange(...args))),
            id: "uploadMedia",
            multiple: _ctx.isArray,
            type: "file",
            ref: "fileInput",
            accept: ".pdf,.jpg,.jpeg,.png",
            class: "input-file-media"
          }, null, 40, _hoisted_7)
        ])
      ], 32),
      (_ctx.files[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("legend", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("componentSelectedFile")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.$t("componentUploadTo")), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.folder) = $event)),
                      class: "input select-folder"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store?.state?.medias, (folder) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: folder.code
                        }, _toDisplayString(folder.title), 9, _hoisted_14))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.folder]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, fileIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.name,
                      class: "list-selected-media"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.beforeUploadIndex) = $event)),
                        value: fileIndex,
                        type: "radio",
                        checked: _ctx.beforeUploadIndex === fileIndex,
                        class: "btn-radio-before-check"
                      }, null, 8, _hoisted_16), [
                        [_vModelRadio, _ctx.beforeUploadIndex]
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_c_img, {
                          src: _ctx.fileToPath(file),
                          isPath: false,
                          class: "img img-cover"
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(file.name), 1),
                        _createElementVNode("div", _hoisted_20, [
                          (_ctx.uploadIndexIndex === fileIndex && _ctx.isUploading)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: _normalizeStyle({width: _ctx.uploadPercentage + '%'}),
                                class: _normalizeClass([{'active-uploading' : _ctx.isUploading}, "progress-bar"])
                              }, null, 6))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21))
                        ])
                      ]),
                      _createElementVNode("div", {
                        onClick: $event => (_ctx.removeDraftFile(fileIndex), _ctx.beforeUploadIndex = -1),
                        class: "btn-remove-media"
                      }, _hoisted_24, 8, _hoisted_22),
                      _createElementVNode("div", _hoisted_25, [
                        (_ctx.beforeUploadIndex !== fileIndex)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_26, _toDisplayString(_ctx.$t("componentUpload")), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isUploading && _ctx.beforeUploadIndex === fileIndex)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_27, _toDisplayString(_ctx.$t("componentUploading")) + "...", 1))
                          : _createCommentVNode("", true),
                        (!_ctx.isUploading && _ctx.beforeUploadIndex === fileIndex)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.submitUpload && _ctx.submitUpload(...args))),
                              class: "btn btn-danger btn-sm ml6"
                            }, _toDisplayString(_ctx.$t("componentUpload")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("legend", _hoisted_30, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t("componentUploadedFile")), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverMedia, (file, fileIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: fileIndex,
                  class: "list-selected-media",
                  style: {"width":"100%"}
                }, [
                  (_ctx.isArray)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.form.code) = $event)),
                        value: file.key,
                        onChange: _cache[8] || (_cache[8] = (...args) => (_ctx.onChangeMedia && _ctx.onChangeMedia(...args))),
                        type: "checkbox",
                        class: "btn-radio-before-check"
                      }, null, 40, _hoisted_33)), [
                        [_vModelCheckbox, _ctx.form.code]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.form.code) = $event)),
                        value: file.key,
                        onChange: _cache[10] || (_cache[10] = (...args) => (_ctx.onChangeMedia && _ctx.onChangeMedia(...args))),
                        type: "radio",
                        class: "btn-radio-before-check"
                      }, null, 40, _hoisted_34)), [
                        [_vModelRadio, _ctx.form.code]
                      ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_c_img, {
                      src: _ctx.$helper?.getFullImage(file?.key),
                      class: "img img-cover"
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("p", _hoisted_37, _toDisplayString(file.key || "N/A"), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          (!_ctx.serverMedia[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_c_empty)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}